import { Header} from "./HeaderModal.style";
import LogoEupha from '../../assets/eupha-blanco.png'
import { IoClose } from "react-icons/io5";

const HeaderModal = () => {
  return (
        <Header>
          <a href="/"><img src={LogoEupha} alt="" /></a>
          <a href="/"><IoClose /></a>
        </Header>
  );
}

export default HeaderModal;